import React, { useState } from 'react'
import { Container, Card, Form, Button } from 'react-bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useAppDispatch } from 'src/redux/storeHooks'
import { requestPasswordForgetAsync } from 'src/redux/actions/authActions'
import useAppToast from 'src/hooks/useAppToast'
import { Link } from 'react-router-dom'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email format')
    .min(3, 'Minimum 3 characters')
    .max(50, 'Maximum 50 characters')
    .required('Email is required'),
})

const ForgotPasswordPage = () => {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const dispatch = useAppDispatch()
  const { successToast, errorToast } = useAppToast()

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values) => {
      setLoading(true)
      setHasErrors(undefined)

      dispatch(requestPasswordForgetAsync({ email: values.email }))
        .then((response) => {
          if (response?.payload?.status_code === 200) {
            formik.resetForm()
            successToast(response?.payload?.massage)
            setHasErrors(false)
          } else {
            errorToast("Something went wrong. Try again.")
            setHasErrors(true)
          }
        })
        .catch((error) => {
          console.error(error)
          errorToast("An error occurred.")
          setHasErrors(true)
        })
        .finally(() => setLoading(false))
    },
  })

  return (
    <Container className="py-5 d-flex justify-content-center align-items-center">
      <style>
        {`
          .floating-label-group {
            position: relative;
            margin-bottom: 1.5rem;
          }

          .floating-label-group input {
            border: 1px solid #ced4da;
            border-radius: 0.5rem;
            padding: 1rem 0.75rem 1rem 0.75rem;
            font-size: 1rem;
            width: 100%;
            transition: border-color 0.3s, padding-top 0.3s;
            background: none;
          }

          .floating-label-group label {
            position: absolute;
            top: 1rem;
            left: 0.75rem;
            font-size: 1rem;
            color: #6c757d;
            transition: 0.2s ease all;
            pointer-events: none;
            background: white;
            padding: 0 0.5rem;
            transform-origin: left top;
          }

          .floating-label-group input:focus {
            outline: none;
            border-color: #0d6efd;
          }

          .floating-label-group input:focus + label,
          .floating-label-group input:not(:placeholder-shown) + label {
            top: -0.7rem;
            left: 0.6rem;
            font-size: 0.8rem;
            color: #0d6efd;
            padding: 0 0.25rem;
          }

          .google-button {
            border: 1px solid #0d6efd;
            color: #0d6efd;
            transition: all 0.3s ease-in-out;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
          }

          .google-icon {
            color: #0d6efd;
            transition: color 0.3s ease-in-out;
          }

          .google-button:hover {
            background-color: #0d6efd;
            color: white;
            transform: scale(1.02);
          }

          .google-button:hover .google-icon {
            color: white;
          }

          .card-style {
            background-color: #ffffff;
            border-radius: 1rem;
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
            width: 100%;
            max-width: 500px;
          }
        `}
      </style>

      <Card className="p-4 card-style">

        {/* <Button
        variant="outline-primary"
        className="google-button d-flex align-items-center justify-content-center gap-2 w-100 mb-4"
        >
            <img
                src="https://cdn1.iconfinder.com/data/icons/google-s-logo/150/Google_Icons-09-512.png"
                alt="Google logo"
                width="20"
                height="20"
                className="google-icon"
            />
            Continue with Google
        </Button> */}

        <div className="text-center mb-2">
          <h4 className="fw-bold mb-2">Forgot Password</h4>
          <p className="text-muted">Enter your email to receive password reset instructions.</p>
        </div>

        {hasErrors === true && (
          <div className="alert alert-danger py-2 mb-4">
            <strong>Error:</strong> Email not recognized. Please try again.
          </div>
        )}

        {/* {hasErrors === false && (
          <div className="alert alert-success py-2">
            <strong>Success:</strong> Please check your inbox for reset instructions.
          </div>
        )} */}

        <Form onSubmit={formik.handleSubmit}>
          <div className="floating-label-group">
            <Form.Control
              type="email"
              placeholder=" "
              required
              {...formik.getFieldProps('email')}
              isInvalid={formik.touched.email && !!formik.errors.email}
            />
            <Form.Label>Email</Form.Label>
            {formik.touched.email && formik.errors.email && (
              <div className="invalid-feedback">{formik.errors.email}</div>
            )}
          </div>

          <Button type="submit" variant="primary" className="w-100" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </Button>

          <div className="text-center mt-3">
            <Link to="/auth/login-page" className="text-decoration-none">Back to Login</Link>
          </div>
        </Form>
      </Card>
    </Container>
  )
}

export default ForgotPasswordPage
